import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ApiRequest } from '../../services/api';
import CustomTableRow from './CustomTableRow';
import Loading from '../HelperElements/Loader/Loading';

function TiempoDiaList() {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadItems = async () => {
      try {
        setIsLoading(true);
        const data = await ApiRequest("api/TiemposDia/ListarTiemposDia");
        const sortedData = [...(data || [])].sort((a, b) =>
          a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
        );
        setItems(sortedData);
      } catch (error) {
        console.error("Error fetching tiempos del día:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadItems();
  }, []);

  const normalizeText = (text) =>
    text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  const filteredItems = items.filter((item) =>
    normalizeText(item.nombre).includes(normalizeText(searchTerm))
  );

  const handleAddNew = () => {
    navigate('/Dashboard/TiempoDia/New');
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Tiempos del día
      </Typography>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Loading />
        </Box>
      ) : (
        <>
          {/* Buscador */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
              gap: 2
            }}
          >
            <div className="contenedor-busqueda">
              <input
                placeholder="Buscar tiempo del día"
                id="input-tiempo"
                className="busqueda-input"
                name="text"
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <label className="etiqueta-busqueda" htmlFor="input-tiempo">
                <svg className="icono-busqueda" viewBox="0 0 512 512">
                  <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                </svg>
              </label>
            </div>

            <Button className="button" variant="contained" color="primary" onClick={handleAddNew}>
              Nuevo
              <svg fill="currentColor" viewBox="0 0 24 24" className="icon">
                <path
                  clipRule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                  fillRule="evenodd"
                ></path>
              </svg>
            </Button>
          </Box>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                <TableCell>Nombre</TableCell>
                  <TableCell>Imagen</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredItems.map((item, index) => (
                  <CustomTableRow key={index} item={item} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {filteredItems.length === 0 && (
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                textAlign: 'center',
                color: '#9e9e9e',
                fontStyle: 'italic'
              }}
            >
              No se encontraron tiempos del día
            </Typography>
          )}
        </>
      )}
    </Box>
  );
}

export default TiempoDiaList;
